/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {AttachmentVO} from "./attachment-vo.model";
import { AttachmentSaveLocationType } from './attachment-save-location-type.enum';

export class BaseAttachmentDTO {

  uuid: string | undefined = undefined;
  fileStoreAttachmentUuid: string | undefined = undefined;
  fileName: string | undefined = undefined;
  fileType: string | undefined = undefined;
  fileSizeKB: number | undefined = undefined;
  validFrom: string | undefined = undefined;
  validTo: string | undefined = undefined;
  description: string | undefined = undefined;
  version: number | undefined = undefined;
  officialDocument: boolean | undefined = undefined;
  attachmentSaveLocation: AttachmentSaveLocationType | undefined = undefined;

  public static fromAttachmentVo(attachmentVo: AttachmentVO): BaseAttachmentDTO{
    const baseAttachmentDto = new BaseAttachmentDTO();
    baseAttachmentDto.fileStoreAttachmentUuid = attachmentVo.fileStoreAttachmentUuid;
    baseAttachmentDto.fileName = attachmentVo.fileName;
    baseAttachmentDto.fileSizeKB = attachmentVo.fileSizeKB;
    baseAttachmentDto.fileType = attachmentVo.fileType;
    baseAttachmentDto.attachmentSaveLocation = attachmentVo.attachmentSaveLocation;

    return baseAttachmentDto;
  }
}
